<template>
  <tr class="v-centered">
    <td>
      <v-checkbox
        :value="selected.indexOf(value.id) != -1"
        @input="toggleSelected(value.id)">
      </v-checkbox>
    </td>

    <td>
      <v-select
        v-if="categories.length > 0"
        required
        :options="categories"
        item-text="category"
        item-value="id"
        v-model="value.product_category_id"
      />
    </td>

    <td>
      <v-select
        v-if="products.length > 0"
        required
        :options="products"
        item-text="name"
        item-value="id"
        v-model="value.product_master_id"
      />
      <div class="has-text-grey-light" v-else>
        <span v-if="value.product_category_id">
          No products in this category
        </span>
        <span v-else>
          Select a category
        </span>
      </div>
    </td>

    <td>
      <span v-if="value.product_master_id">
        {{ product.desc }}
      </span>
      <div class="has-text-grey-light" v-else>
        Select a product
      </div>
    </td>

    <td>
      <span v-if="value.product_master_id">
        <a 
          v-if="product.image"
          @click="launchPreview(product.image)">
          Sample Image
        </a>
        <div v-else class="has-text-grey-light">
          No image available
        </div>
      </span>
      <div class="has-text-grey-light" v-else>
        Select a product
      </div>
    </td>

    <template v-if="value.product_category_id">
      <td
        colspan="3" 
        class="has-text-grey-light"
        v-if="!productCategory.has_dimensions">
        Product Category does not have dimensions
      </td>
      <template v-else>
        <td>
          <v-content-editable
            v-model="value.length_in_str"/>
        </td>
        <td>
          <v-content-editable
            v-model="value.width_in_str"/>
        </td>
        <td>
          <v-content-editable
            v-model="value.thick_in_str"/>
        </td>
      </template>
    </template>

    <td 
      colspan="3"
      class="has-text-grey-light"
      v-else>
      Select a category
    </td>

    <td>
      <v-text-field 
        required
        v-model="value.finished_qty"/>
    </td>

    <td>
      <div v-if="value.product_master_id">
        {{ product.unit ? product.unit.unit_display_name : '' }}
      </div>
      <div class="has-text-grey-light" v-else>
        Select a product
      </div>
    </td>

    <td>
      <div class="buttons buttons-right">
        <button  
          @click="removeRow(value.id)"
          class="button is-small">
          <span class="has-text-grey icon">
            <i class="fas fa-trash"></i>
          </span>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import VCheckbox from '@/components/base/VCheckbox'
import VSelect from '@/components/base/VSelect'
import VContentEditable from '@/components/base/VContentEditable'
import VTextField from '@/components/base/VTextField'
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Object
    }
  },
  components: { VSelect, VTextField, VContentEditable, VCheckbox },
  data() {
    return {
      products: []
    }
  },
  computed: {
    // assuming that the parent will get product categories
    ...mapState("products", ["selected", "categories"]),
    product({ value }) {
      return this.products.filter(d => d.id == value.product_master_id)[0];
    },
    productCategory({ value }) {
      return this.categories.filter(d => d.id == value.product_category_id)[0];
    }
  },
  watch: {
    'value.product_category_id'(categoryId) {
      this.value.product_master_id = null;
      this.getProducts(categoryId);
    }
  },
  methods: {
    ...mapMutations("products", ["toggleSelected"]),
    getProducts(categoryId) {
      this.$http.products.get(
        { product_category_id: categoryId, 
          simplified: true,
          per_page: 1000 }
      ).then(resp => {
        this.products = resp.data.results;
      })
    },
    launchPreview(image) {
      this.$emit("preview", image);
    },
    removeRow(id) {
      this.$emit("remove", id);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>